import { styled, lighten } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const Container = styled(Grid)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",

  ".MuiButton-root": {
    color: theme.palette.primary.main,
    border: "none",
    margin: "0 0 0 auto",

    "&:hover": {
      border: "none",
    },
  },
}));

export const Documents = styled(Grid)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  gap: "5px",

  "& > .MuiGrid-root": {
    width: "60px",
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    flexWrap: "wrap",
    cursor: "pointer",

    "& svg": {
      fontSize: "1.8em",
      color: theme.palette.primary.main,
    },

    "& .MuiTypography-root": {
      fontSize: "0.7em",
    },
  },
}));

export const Actions = styled(Grid)({
  display: "flex",
  gap: "10px",
});

export const FilesInfo = styled(Grid)(({ theme }) => ({
  height: "100%",
  display: "flex",
  alignItems: "center",
  position: "relative",
  overflow: "visible",

  ".MuiGrid-root": {
    visibility: "hidden",
    opacity: 0,
    transition: "all .3s ease",
    border: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
    backgroundColor: lighten(theme.palette.secondary.light, 0.5),
    padding: "10px",
    position: "absolute",
    top: 0,
    right: 20,
    zIndex: 99,
  },

  svg: {
    fontSize: "1.3em",
    cursor: "pointer",
  },

  "svg:hover + .MuiGrid-root, .MuiGrid-root:hover": {
    visibility: "visible",
    opacity: 1,
  },
}));
